<!--
 * @Author: guoguo ybbhai@hotmail.com
 * @Date: 2023-10-07 08:26:17
 * @LastEditors: guoguo ybbhai@hotmail.com
 * @LastEditTime: 2023-10-19 15:01:16
 * @FilePath: \web\src\layout\index.vue
 * @Description: 管理页布局
-->
/**
* @description: 
* @version: V1.0
* @date: 2023-10-07
* @author: guoguo
*/
<template>
  <div>
    <el-row :gutter="5">
      <el-col :span="3">
        <el-menu
          default-active="2"
          class="el-menu-vertical-demo"
          @open="handleOpen"
          @close="handleClose"
          background-color="#545c64"
          active-text-color="#ffd04b"
          @select="handleSelect">
          <el-menu-item v-for="(item, i) in menues" :key="i">
            <i :class="item.class"/>
            <!-- <span slot="title">{{ item.title }}}</span> -->
            <router-link :to="item.path">{{ item.title }}</router-link>
          </el-menu-item>
        </el-menu>
      </el-col>
      <el-col :span="21">
        <router-view />
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'Layout',
  data () {
    return {
      menues: [
        {
          index: 1,
          title: '基金会信息管理平台',
          path: '/administrator/main',
          class: 'el-icon-document'
        },
        {
          index: 2,
          title: '分类管理',
          path: '/administrator/category',
          class: 'el-icon-folder'
        },
        {
          index: 3,
          title: '友情链接管理',
          path: '/administrator/friendlyLink',
          class: 'el-icon-link'
        },
        {
          index: 4,
          title: '项目管理',
          path: '/administrator/project',
          class: 'el-icon-s-check'
        }
      ]
    };
  },
  created() {}, // 生命周期 - 创建完成
  mounted() {
    // 获取登陆用户信息，动态生成菜单
    let role = window.sessionStorage.getItem('role')
    if (role == '超级管理员') {
      this.menues.push(
        {
          index: 5,
          title: '员工管理',
          path: '/administrator/staff',
          class: 'el-icon-s-custom'
        }
      )
      this.menues.push(
        {
          index: 6,
          title: '用户管理',
          path: '/administrator/adedit',
          class: 'el-icon-user'
        }
      )
    }
  }, // 生命周期 - 挂载完成
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
  components: {},
  watch: {}, // 监控data中的数据变化
  computed: {}, // 计算属性，会监听依赖属性值随之变化
  methods: {
    handleOpen(index, keyPath) {},
    handleClose(index, keyPath) {},
    handleSelect(index, keyPath) {
      console.log(index, keyPath);
      // this.$router.push({ path: this.menues[index - 1].path })
    },
  }, // 方法集合
}

</script>
<style lang='less' scoped>
.router-link-active {
  text-decoration: none;
  color: yellow;
}
a{
  text-decoration: none;
  color: white;
}
</style>